import BProject from "./model/BProject";

function skSaveProject(project) {
	const ser = project.serialize();
	localStorage.setItem("sb-default-saved", JSON.stringify(ser));

	return true;
}

function skLoadProject() {
	const storedRawData = localStorage.getItem("sb-default-saved");

	let j = null;
	try {
		if (storedRawData) {
			j = JSON.parse(storedRawData);
		}
	} catch(e) {
		console.log("[Load error] Invalid json");
	}

	if (j) {
		const loadedProject = new BProject(j.flags, j.id);
		loadedProject.deserialize(j);
		return loadedProject;
	}

	return null;
}

export { skSaveProject, skLoadProject };